export default __webpack_public_path__ + "static/media/CeLLife-Electrical-Fingerprint_logo_pos_RGB.2e7ad8c5.png";